/**
 * Routes belonging to someone who is not (yet) a user of this app.
 *
 * Two things key off this and they must agree, which is why it isn't defined twice:
 *
 * 1. Navigation never renders here. A coach opening an invite link in their own browser used to see
 *    the signup page wearing their own Clients/Library tabs and a Sign out button -- an invitation to
 *    sign themselves out mid-flow, and on a shared machine, navigation into someone else's account.
 * 2. These pages always render light. They are the brand's front door -- the same face as the business
 *    card -- so they present the same way to every visitor rather than inheriting a theme choice made
 *    inside the app.
 */
const PUBLIC_PATH_PREFIXES = ["/signin", "/signup", "/forgot-password", "/privacy", "/terms"];

export function isPublicPath(pathname: string): boolean {
  return pathname === "/" || PUBLIC_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}
